// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NiGfF9c6tTjULzj1RNB_{align-self:end}`, "",{"version":3,"sources":["webpack://./../../components/react/src/components/CheckoutCart/PriceDetailPromo/priceDetailPromo.module.scss"],"names":[],"mappings":"AAAA,sBACE,cAAA","sourcesContent":[".priceDetailPromo {\n  align-self: end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"priceDetailPromo": `NiGfF9c6tTjULzj1RNB_`
};
export default ___CSS_LOADER_EXPORT___;
